export default __webpack_public_path__ + "static/media/bacqueville19.3f04dfef.jpg";